import React from 'react';
import Hero from '../components/Hero';
import BrandSection from '../components/brandSection';
import ServicesSection from '../components/ServicesSection';
import PortfolioGrid from '../components/portfolioGrid';
import SlidingText from '../components/SlidingText';
import ContactForm from '../components/ContactForm';


const Home: React.FC = () => {
  return (
    <main className="overflow-hidden">
      <Hero />
      <BrandSection /> 
      <ServicesSection />
      <PortfolioGrid />
      <SlidingText />
      <ContactForm />
    </main>
  );
};

export default Home;